export default __webpack_public_path__ + "static/media/icon.91b3d8d1.svg";